import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Tag } from '../../models/tag';
import { CrudService } from '../crud.service';

@Injectable({
  providedIn: 'root',
})
export class TagService extends CrudService<Tag> {
  protected basePath = 'tag'; // Specific for TagService
  public instanceType = 'tag'; // Used in base service for constructing URLs

  constructor(http: HttpClient) {
    super(http);
  }
}
